import { render, staticRenderFns } from "./Leftmenu.vue?vue&type=template&id=1b996e98&"
import script from "./Leftmenu.vue?vue&type=script&lang=js&"
export * from "./Leftmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports